<template>
  <form @submit.prevent="onSubmit">
    <p v-if="messageSuccess" class="mt-0 text-center text-success">
      <b>{{ messageSuccess ? messageSuccess : '' }}</b>
    </p>
    <p v-if="messageFailure" class="mt-0 text-center text-danger">
      <b>{{ messageFailure ? messageFailure : '' }}</b>
    </p>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="arbitre_nom">Nom et Postnom</label>
        <label class="input-group-text" for="arbitre_postnom"></label>
      </div>
      <input id="arbitre_nom"
             v-model="dataForm.nom"
             class="form-control"
             name="arbitre_nom"
             placeholder="Entrez nom de l'arbitre"
             type="text">
      <input id="arbitre_postnom"
             v-model="dataForm.postnom"
             class="form-control"
             name="arbitre_postnom"
             placeholder="Postnom de l'arbitre"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="arbitre_prenom">Prénom</label>
      </div>
      <input id="arbitre_prenom"
             v-model="dataForm.prenom"
             class="form-control"
             name="arbitre_prenom"
             placeholder="Entrez le prénom de l'arbitre"
             type="text">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="fileToUpload">Photo Passeport</label>
      </div>
      <input id="fileToUpload"
             ref="fileToUpload"
             @change="handleFileToUpload"
             lang="fr"
             type="file"
             class="form-control"
             accept=".png, .jpeg, .jpg">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <label class="input-group-text" for="arbitre_description">Description</label>
      </div>
      <textarea id="arbitre_description"
                v-model="dataForm.description"
                class="form-control"
                name="arbitre_description"
                placeholder="Entrez une courte description de l'arbitre">
      </textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="arbitre_date_naissance">Date de naissance</label>
      </div>
      <input id="arbitre_date_naissance"
             v-model="dataForm.date_naissance"
             class="form-control"
             name="arbitre_date_naissance"
             type="date">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="arbitre_nationalite">Nationalité</label>
      </div>
      <select id="arbitre_nationalite"
              v-model="dataForm.nationalite"
              class="custom-select"
              name="arbitre_nationalite">
        <option :key="'nationalite'+idx"
                :value="nationalite.value"
                v-for="(nationalite, idx) in getNationalites">{{ nationalite.nationalites }}</option>
      </select>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="arbitre_nombre_matchs_arbitres">Nombre des matchs arbitrés</label>
      </div>
      <input id="arbitre_nombre_matchs_arbitres"
             v-model="dataForm.nombre_matchs_arbitres"
             class="form-control"
             name="arbitre_nombre_matchs_arbitres"
             placeholder="Entrez le nombre total des matchs arbitrés par l'arbitre"
             type="number">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="arbitre_niveau">Niveau de l'arbitre</label>
      </div>
      <select id="arbitre_niveau"
              v-model="dataForm.niveau"
              class="custom-select"
              name="arbitre_niveau">
        <option :key="'niveau'+idx"
                :value="niveau"
                v-for="(niveau, idx) in getNiveauxArbitres">{{ niveau }}</option>
      </select>
    </div>
    <div class="mt-4 mb-3 text-center">
      <button class="btn btn-sm btn-success" type="submit">SAUVEGARDER</button>
    </div>
  </form>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
  name: "Create",
  props: {},
  data() {
    return {
      messageSuccess: '',
      messageFailure: '',
      dataForm: {
        nom: '',
        postnom: '',
        prenom: '',
        photo_passeport: '',
        description: '',
        commentaires: '',
        historique: '',
        date_naissance: '',
        nombre_matchs_arbitres: '',
        niveau: '',
        nationalite: 'Congolais - Kinshasa',
        table: 'arbitres',
      },
      file: '',
    }
  },
  watch: {
    messageSuccess : function () {
      let vm = this;
      setTimeout( () => vm.messageSuccess = "", 5000)
    },
    messageFailure : function () {
      let vm = this;
      setTimeout( () => vm.messageFailure = "", 5000)
    }
  },
  components: {},
  methods: {
    ...mapMutations([]),
    ...mapActions([
      'axiosPostData',
      'axiosPostFileData',
    ]),
    handleFileToUpload(){
      this.file = this.$refs.fileToUpload.files[0];
    },
    uploadFile () {
      let formData = new FormData()
      let fileName = ''
      if(this.dataForm.nom && this.dataForm.postnom && this.dataForm.prenom){
        fileName = this.dataForm.prenom.toLowerCase() + '_' +
                   this.dataForm.postnom.toLowerCase() + '_' +
                   this.dataForm.nom.toLowerCase() + '_' + Math.floor(Math.random() * 1000000) + 1
      }
      formData.append('fileToUpload', this.file)
      formData.append('fileName', fileName)
      formData.append('to', "arbitres")
      if(this.file){
        this.axiosPostFileData(formData)
            .then(data => {
              this.dataForm.photo_passeport = data[2];
            })
            .catch(data => {})
      }
      this.axiosPostData(this.dataForm)
          .then((data) => {
            if((data.data.status === 'reussite' && data.status) === 201)
              this.messageSuccess = "Arbitre ajouté avec succès !"
            else
              this.messageFailure = "Une erreur est survenue lors de l'insertion de l'arbitre !"
          })
          .catch((error) => {
            this.messageFailure = "Une erreur est survenue lors de l'insertion de l'arbitre !"
          })
    },
    onSubmit() {
      this.uploadFile()
    }
  },
  computed: {
    ...mapGetters([
        'getNationalites',
        'getNiveauxArbitres',
    ])
  },
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  }
}
</script>

<style lang="scss" scoped>
form {
  & > div {
    & > div {
      & > label, & > label {
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }

      & > label.customized-label {
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }

    & > input, & > select {
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/arbitres/components/Create.vue